package org.catharsis.spendtel.feature.presentation.expensereport

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.coroutines.yield
import org.catharsis.spendtel.core.platform.sharePng
import org.catharsis.spendtel.core.platform.shareText
import org.catharsis.spendtel.feature.presentation.ExpenseReportEffect
import org.catharsis.spendtel.feature.presentation.ExpenseReportViewModel
import org.catharsis.spendtel.feature.share.renderShareImageCard

@Composable
fun ExpenseReportShareEffect(
    viewModel: ExpenseReportViewModel,
    onCopiedToClipboard: () -> Unit = {},
    onImageDownloaded: () -> Unit = {},
    onShareFailed: (String) -> Unit = {},
) {
    LaunchedEffect(viewModel) {
        viewModel.effect.collect { effect ->
            when (effect) {
                is ExpenseReportEffect.Share -> {
                    val sharedNatively = shareText(effect.title, effect.text)
                    if (!sharedNatively) {
                        onCopiedToClipboard()
                    }
                }

                is ExpenseReportEffect.ShareImage -> {
                    yield()
                    val pngBytes = renderShareImageCard(effect.card)
                    yield()
                    val sharedNatively = sharePng("spendtel-story.png", pngBytes)
                    if (!sharedNatively) {
                        onImageDownloaded()
                    }
                }

                is ExpenseReportEffect.ShareLink -> {
                    val sharedNatively = shareText("Share your SpendTel story", effect.url)
                    if (!sharedNatively) {
                        onCopiedToClipboard()
                    }
                }

                is ExpenseReportEffect.ShareFailed -> {
                    onShareFailed(effect.message)
                }
            }
        }
    }
}
